import React, { useState, useEffect } from "react";
// import customInput from "../../assets/scss/DiegoVpn.module.scss"; // File sudah dihapus
import checkList from "../../assets/images/icons/checklist.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import {
  addToCart,
  changeProductFromCart,
} from "features/common/layouts/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { formatIDR } from "helpers/utils";
import { getProducts } from "features/diegoVpn/diegoVpnSlice";
import Spinner from "react-bootstrap/Spinner";
import { useQuery } from "helpers/utils";
import PromoKaosTumbler from "components/PromoKaosTumbler";
import { notifyError, notifySuccess } from "components/ToastMessage";
import MainLayouts from "layouts/MainLayouts";
import { setOrderParams } from "features/common/layouts/cartSlice";

const DiegoVpnOrder = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = useQuery();
  const product = useSelector((state) => state.vpn);
  const { productsList } = useSelector((state) => state.cart);
  const [selectedProduct, setSelectedProduct] = useState("monthly");
  const [selectedPID, setSelectedPID] = useState("453");
  const [selectedPrice, setSelectedPrice] = useState("35000");
  const [selectedProductName, setSelectedProductName] = useState("VPN Lite");
  const [selectedAmountAccount, setSelectedAmountAccount] = useState(1);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pid = params.get("pid");
    const billingcycle = params.get("billingcycle");
    dispatch(setOrderParams({ pid, billingcycle }));
  }, [location.search, dispatch]);

  const { gid = 685 } = product?.vpn[0] ?? 685;

  const [showPromo, setShowPromo] = useState(false);
  const { total } = useSelector((state) => state.cart);

  useEffect(() => {
    if (query.pid && query.billingcycle) {
      dispatch(getProducts("453,454,455"));
      setSelectedPID(query.pid);
      setSelectedProduct(query.billingcycle);
      setShowPromo(true);
      if (query.pid === "453") {
        setSelectedProductName("VPN Lite");
      } else if (query.pid === "454") {
        setSelectedProductName("VPN Unlimited");
      } else if (query.pid === "455") {
        setSelectedProductName("VPN Corporate");
      }
    }
  }, [dispatch, query]);

  useEffect(() => {
    const period = query.billingcycle;
    if (product.vpn && query.pid) {
      if (query.pid === "453") {
        setSelectedPrice(product.vpn[0].pricing.IDR[period]);
      } else if (query.pid === "454") {
        setSelectedPrice(product.vpn[2].pricing.IDR[period]);
      } else if (query.pid === "455") {
        setSelectedPrice(product.vpn[1].pricing.IDR[period]);
      }
    }
  }, [product.vpn, query]);

  useEffect(() => {
    if (location.pathname === "/orderdiegovpn") {
      dispatch(getProducts("453,454,455"));
    }
  }, [dispatch, location]);

  const updateProductInCart = (index, productName) => {
    setSelectedPrice(product.vpn[index].pricing.IDR[productName]);
    setSelectedProduct(productName);
    const checkVPN = productsList.find((list) => list.pid === selectedPID);
    if (checkVPN) {
      const vpnProduct = {
        pid: selectedPID,
        gid: +gid,
        name: selectedProductName,
        price:
          product.vpn[index].pricing.IDR[productName] * selectedAmountAccount,
        billingcycle: productName,
        account: selectedAmountAccount,
        type: "vpn",
      };
      dispatch(changeProductFromCart(vpnProduct));
    }
  };

  const handleClickProduct = (productName) => {
    if (selectedPID === "453") {
      updateProductInCart(0, productName);
    } else if (selectedPID === "454") {
      updateProductInCart(2, productName);
    } else if (selectedPID === "455") {
      updateProductInCart(1, productName);
    }
  };

  const updateCartWithAkun = (index, akun) => {
    if (akun <= 0 || isNaN(akun) || akun === "") {
      notifyError("Maaf, jumlah akun vpn minimal 1!");
      return;
    }
    const vpnProduct = {
      pid: selectedPID,
      gid: +gid,
      name: selectedProductName,
      price: product.vpn[index].pricing.IDR[selectedProduct] * akun,
      billingcycle: selectedProduct,
      account: akun,
      type: "vpn",
    };
    dispatch(changeProductFromCart(vpnProduct));
  };

  const incrementAccount = () => {
    if (selectedAmountAccount < 9999) {
      const newAmount = selectedAmountAccount + 1;
      setSelectedAmountAccount(newAmount);
      updateCartWithAkunForCurrentProduct(newAmount);
    }
  };

  const decrementAccount = () => {
    if (selectedAmountAccount > 1) {
      const newAmount = selectedAmountAccount - 1;
      setSelectedAmountAccount(newAmount);
      updateCartWithAkunForCurrentProduct(newAmount);
    }
  };

  const updateCartWithAkunForCurrentProduct = (akun) => {
    const indexMap = { 453: 0, 454: 2, 455: 1 };
    const index = indexMap[selectedPID];
    updateCartWithAkun(index, akun);
  };

  const handleInputAkun = (akun) => {
    const validAkun = Math.min(Number(akun) || 1, 999);
    setSelectedAmountAccount(validAkun);
    const checkVPN = productsList.find((list) => list.pid === selectedPID);
    if (checkVPN) {
      if (selectedPID === "453") {
        updateCartWithAkun(0, validAkun);
      } else if (selectedPID === "454") {
        updateCartWithAkun(2, validAkun);
      } else if (selectedPID === "455") {
        updateCartWithAkun(1, validAkun);
      }
    }
  };

  const addProductToCart = (billingCycle) => {
    const vpnProduct = {
      pid: selectedPID,
      gid: +gid,
      name: selectedProductName,
      price: selectedPrice * selectedAmountAccount,
      billingcycle: billingCycle,
      account: selectedAmountAccount,
      type: "vpn",
    };
    // console.log("vpnProduct ::", vpnProduct);
    dispatch(addToCart(vpnProduct));
  };

  const handlerSendToCart = (e) => {
    e.preventDefault();
    if (
      selectedAmountAccount <= 0 ||
      isNaN(selectedAmountAccount) ||
      selectedAmountAccount === ""
    ) {
      notifyError("Maaf, jumlah akun vpn minimal 1!");
      return;
    }

    for (const vpn of productsList) {
      if (vpn.type === "vpn") {
        notifyError("Produk Diego VPN sudah berada di dalam cart!");
        return;
      }
    }

    if (
      [
        "monthly",
        "quarterly",
        "semiannually",
        "annually",
        "biennially",
      ].includes(selectedProduct)
    ) {
      addProductToCart(selectedProduct);
      notifySuccess("Produk berhasil ditambahkan ke keranjang.");
    }
  };

  const updateProductDetails = (index, pid, productName) => {
    setSelectedPID(pid);
    setSelectedPrice(product.vpn[index].pricing.IDR[selectedProduct]);
    setSelectedProductName(productName);
    const vpnProduct = {
      pid,
      gid: +gid,
      name: productName,
      price:
        product.vpn[index].pricing.IDR[selectedProduct] * selectedAmountAccount,
      billingcycle: selectedProduct,
      account: selectedAmountAccount,
      type: "vpn",
    };
    dispatch(changeProductFromCart(vpnProduct));
  };

  const getProductDetails = (pid) => {
    switch (pid) {
      case "453": // Diego VPN LITE
        return [
          { text: "40GB Bandwidth" },
          { text: "VPN Indonesia" },
          { text: "Support Many Devices" },
          { text: "Encryption" },
          { text: "Support 24/7" },
          { text: "Simultaneous User (Optional)" }
        ];
      case "454": // Diego VPN Unlimited
        return [
          { text: "Unlimited Bandwidth" },
          { text: "VPN Indonesia" },
          { text: "Encryption" },
          { text: "Support Many Devices" },
          { text: "Support 24/7" },
          { text: "Extra Users (Optional)" },
          { text: "Dedicated IP (Optional)" }
        ];
      case "455": // Diego VPN Corporate
        return [
          { text: "Unlimited Bandwidth" },
          { text: "2 Users" },
          { text: "Dedicated IP" },
          { text: "Dedicated Node" },
          { text: "VPN Indonesia" },
          { text: "Encryption" },
          { text: "Support Many Devices" },
          { text: "Support 24/7" },
          { text: "Additional Extra Users" },
          { text: "Additional Hardware" }
        ];
      default:
        return [];
    }
  };

  const handlerChangeProduct = (e) => {
    const pid = e.target.value;
    const productName = e.target.selectedOptions[0].innerText;
    if (pid === "453") {
      updateProductDetails(0, pid, productName);
    } else if (pid === "454") {
      updateProductDetails(2, pid, productName);
    } else if (pid === "455") {
      updateProductDetails(1, pid, productName);
    }
  };

  return (
    <MainLayouts summary={false}>
      <div className="card mb-3 shadow-sm" style={{ minHeight: "100px", borderRadius: "16px", borderColor: "transparent" }}>
        <div className="card-body">
          {/* VPN Selection */}
          <div className="form-check py-1 px-4">
            <input
              type="radio"
              className="form-check-input"
              name="DiegoVpn"
              id="DiegoVpn"
              value="DiegoVpn"
              defaultChecked={true}
            />
            <label
              htmlFor="DiegoVpn"
              className="form-check-label fw-bold"
              style={{ fontSize: "18px", marginLeft: "20px" }}
            >
              Diego VPN
            </label>
            <p className="mb-0 mt-2" style={{ marginLeft: "21px" }}>
              VPN aman dan cepat untuk kebutuhan individu dan bisnis Anda
            </p>
          </div>

          {/* Loading Spinner */}
          {product.status === "loading" && (
            <div className="text-center py-4">
              <Spinner animation="border" size="sm" />
            </div>
          )}

          {product.status === "fulfilled" && (
            <div className="px-3 px-md-4 mt-3">
              {/* Product Selection */}
              <div className="mb-3">
                <label htmlFor="diego_vpn" className="form-label fw-bold">Pilih Paket VPN</label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  id="diego_vpn"
                  defaultValue={query.pid ? query.pid : 453}
                  onChange={handlerChangeProduct}
                >
                  {product.vpn &&
                    product.vpn
                      .slice()
                      .sort((a, b) => a.pid - b.pid)
                      .map((data, i) => (
                        <option key={i} value={data.pid} price={data.price}>
                          {data.name}
                        </option>
                      ))}
                </select>
              </div>

              {/* Product Details */}
              <div className="mb-3">
                <label className="form-label fw-bold">Fitur</label>
                <div className="row g-2">
                  {getProductDetails(selectedPID).map((detail, index) => (
                    <div key={index} className="col-12 col-md-6">
                      <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faCheck} className="text-success me-2 flex-shrink-0" />
                        <span className="text-muted small">
                          <strong>{detail.text}</strong>
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Billing Cycle Selection */}
              <div className="mb-3">
                <label className="form-label fw-bold">Pilih Masa Aktif</label>
                <div className="row g-3">
                  {[
                    "monthly",
                    "quarterly",
                    "semiannually",
                    "annually",
                    "biennially",
                  ].map((cycle, index) => {
                    const cycleNames = {
                      monthly: "1 Bulan",
                      quarterly: "3 Bulan",
                      semiannually: "6 Bulan",
                      annually: "1 Tahun",
                      biennially: "2 Tahun",
                    };

                    const indexMap = { 453: 0, 454: 2, 455: 1 };
                    const idx = indexMap[selectedPID];

                    return (
                      <div key={cycle} className="col-12 col-md-6 col-lg-4">
                        <div
                          className={`card position-relative h-100 ${
                            selectedProduct === cycle
                              ? "border border-2 border-primary"
                              : "border"
                            }`}
                          style={{ cursor: "pointer", transition: "all 0.3s ease" }}
                          onClick={() => handleClickProduct(cycle)}
                        >
                          <div className="card-body">
                            <h6 className="fw-bold mb-2">{cycleNames[cycle]}</h6>
                            {product.vpn && (
                              <p className="text-muted mb-0 fw-semibold">
                                {formatIDR(product.vpn[idx].pricing.IDR[cycle])}
                              </p>
                            )}
                          </div>
                          <div
                            className={`position-absolute ${selectedProduct === cycle ? "" : "d-none"
                              }`}
                            style={{ right: "8px", top: "8px" }}
                          >
                            <img src={checkList} alt="checklist.png" width="24" height="24" />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Account Input */}
              <div className="mb-3">
                <label htmlFor="jumlah_akun" className="form-label fw-bold">
                  Jumlah Akun
                </label>
                <div className="input-group" style={{ maxWidth: "300px" }}>
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={decrementAccount}
                    disabled={selectedAmountAccount <= 1}
                  >
                    -
                  </button>
                  <input
                    type="number"
                    min="1"
                    max="999"
                    value={selectedAmountAccount}
                    className="form-control text-center"
                    id="jumlah_akun"
                    onChange={(e) =>
                      handleInputAkun(parseInt(e.target.value) || 1)
                    }
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={incrementAccount}
                    disabled={selectedAmountAccount >= 999}
                  >
                    +
                  </button>
                </div>
              </div>

              {/* Add to Cart Button */}
              <div className="text-center mt-4">
                <button
                  className="btn btn-cta fw-bold py-2 px-5 rounded-5"
                  onClick={handlerSendToCart}
                >
                  Tambahkan ke Keranjang
                </button>
              </div>

              {showPromo && product && (
                <div className="mt-4">
                  <PromoKaosTumbler
                    price={total}
                    billingcycle={selectedProduct}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </MainLayouts>
  );
};

export default DiegoVpnOrder;
